const Filter = ({ filter, index }) => {
	return (
		<div className="filter__wrap" key={filter.slug}>
			<input
				name="news-index-filter"
				id={index}
				type="radio"
				value={filter.slug}
			/>
			<label className="filter" htmlFor={index} tabIndex="0">
				{filter.title}
			</label>
		</div>
	);
};

export default Filter;
